(() => {
  const ELEMENT_NAME = "product-card";
  const attributes = {
    form: `data-${ELEMENT_NAME}-form`,
    quickView: `data-${ELEMENT_NAME}-quick-view`,
    drawer: "data-dynamic-drawer",
    url: "url",
    quickViewTitle: "quick-view-title",
    selectButton: `data-${ELEMENT_NAME}-select-button`,
  };

  class ProductCard extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.$form = this.querySelector(`[${attributes.form}]`);
      this.$productSection = this.querySelector("product-section");
      this.$lastOptions = this.querySelectorAll(
        `product-radio-option[should-not-preselect] input[type="radio"`
      );
      this.$lastSelect = this.querySelector(
        `product-radio-option[should-not-preselect] select`
      );
      this.$drawer = document.querySelector(`[${attributes.drawer}="bottom"]`);
      this.$selectButtons = this.querySelectorAll(`[${attributes.selectButton}]`)

      this.init();
    }

    init() {
      this.addEventListener("submit", (evt) => {
        evt.preventDefault();

        this.addToCart();
      });

      this.$productSection?.addEventListener("optionsChanged", (evt) => {
        if (!evt.detail.shouldNotPreselect) return;

        this.addToCart(evt.detail.variantId);
        this.deselectLastOptions();
      });

      this.addEventListener("click", this.handleClicks.bind(this))
    }

    handleClicks(evt) {
      this.onSelectButtonClick(evt)
      this.onQuickViewButtonClick(evt)
    }

    onQuickViewButtonClick(evt) {
      const $el = evt.target.closest(`[${attributes.quickView}]`);

      if(!$el) return;

      const url = this.getAttribute(attributes.url);
      const bodyHTML = `<component-loader><html-fetcher class="quick-view" loading-class="item-loading" href="${url}${
        url.includes("?") ? "&" : "?"
      }section_id=a-quick-view"></html-fetcher></component-loader>`;
      const title = this.getAttribute(attributes.quickViewTitle);
      this.$drawer.fillAndShow({
        title: title,
        body: bodyHTML,
        type: "quick-view",
      });
    }

    onSelectButtonClick(evt) {
      const $el = evt.target.closest(`[${attributes.selectButton}]`)
      const togglerAttribute = `${attributes.selectButton}-open`
      
      if (!$el) {
        this.$selectButtons.forEach($btn => $btn.removeAttribute(togglerAttribute))
      } else {
        this.$selectButtons.forEach($btn => {
          if ($btn.getAttribute(attributes.selectButton) === $el.getAttribute(attributes.selectButton)) {
            $btn.toggleAttribute(togglerAttribute)
          } else {
            $btn.removeAttribute(togglerAttribute)
          }
        })
        
      }
    }

    addToCart(id) {
      this.toggleAttribute("data-loading");

      const formData = new FormData(this.$form);

      if (id) formData.set("id", id);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((res) => res.json())
        .then((json) => {
          document.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: json.id,
                quantity: 1,
              },
            })
          );
        })
        .catch((err) => console.warn("CART", err))
        .finally(() => this.toggleAttribute("data-loading"));
    }

    deselectLastOptions() {
      this.$lastOptions.forEach(($option) => ($option.checked = false));

      if (!this.$lastSelect) return;

      this.$lastSelect.value = "";
    }
  }

  customElements.define(ELEMENT_NAME, ProductCard);
})();
